<div class="model adduser-model">
    <div class="model-body">
        <div class="model-head">
            <div *ngIf="isSearchKPMG === true" >
                Add KPMG User
            </div>
            <div *ngIf="isSearchKPMG === false">
                Add Client User
            </div>
            <div *ngIf="isSME" >
                Add SME
            </div>
            <div class="model-drawer-close" (click)="closeModel()"><i class="fas fa-times" aria-hidden="true"></i></div>
        </div>
        
        <div class="model-content">
            <form [formGroup]="targetForm">
               
                <section class="add-user-model">
                    <label *ngIf="isSME || !isSearchKPMG">
                        Client Name*
                        <input class="black-input opposite-colors" type="text" name="clientName" formControlName="clientName"  [(ngModel)]="clientName" disabled>
                    </label>
                    <label for="ei-displayName">
                            Display Name*
                            <span *ngIf="(f.displayName.touched || f.displayName.dirty) && f && f.displayName && f.displayName.errors">
                                <span class="required-error" *ngIf="f.displayName.errors.required">(required)</span>
                            </span>
                            <input class="black-input opposite-colors" placeholder="Display Name of User" type="text" no-special-chars="#!$%^<>+=" 
                            (blur)="trimSpecialCharName('displayName');" formControlName="displayName" [(ngModel)]="addUserName"
                                required/>
                    </label>                     
                    <label for="ei-name">
                            Sign-in Name*
                        <span *ngIf="f.signinname.errors && (f.signinname.touched || f.signinname.dirty)">
                            <span class="required-error" *ngIf="f.signinname.errors.required">(required)</span>
                            <span class="required-error" *ngIf="f.signinname.hasError('pattern')">Sign-in name must be a valid email address</span>
                        </span>
                        <input class="black-input opposite-colors" placeholder="Sign-in Name" type="text" no-special-chars="#!$%^<>+=" 
                        formControlName="signinname" (blur)="checkSigninName('signinname')" (keyup)="UpdateEmail($event)"
                        required/>
                    </label>
                    <div class="form-error-sign" *ngIf="IsSignInNameExists">
                            <p>Sign-in name already exists.</p>
                        </div> 
                    <label for="ei-email">
                        Email*
                        <span *ngIf="f.email.errors && (f.email.touched || f.email.dirty)">
                            <span class="required-error" *ngIf="f.email.errors.required">(required)</span>
                            <span class="required-error" *ngIf="f.email.hasError('pattern')">Email address must be in a valid format.</span>
                        </span>
                        <input class="black-input opposite-colors" placeholder="Email" type="text"  no-special-chars="#!$%^<>+=" formControlName="email" required>
                    </label>
                    <div class="form-error-sign" *ngIf="IsEmailExists">
                        <p>Email address already exists.</p>
                    </div>
                   
            
                    <div *ngIf="isInsert" class="archive__toggle" style="padding-top: 10px;" >
                        <span class="mr-4">Contractor</span>          
                            <label class=" mr-2 archive-checkbox" style="width: 40px;">
                                    <toggle-switch (toggleState)="IsContractor($event)"></toggle-switch><span></span>
                            </label>
                    </div>
            
                </section>
            </form>
        </div>
        <div class="model-footer">
            <button type='button' class="btn btn-success" (click)="addUser()">Add User</button> &nbsp;
            <button class="link-button" (click)="closeModel()">Cancel</button>
        </div>
    </div>
</div>